// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","453":"a04ae9d0","455":"1e8cee7c","977":"cf4fdc4b"}[chunkId] + ".chunk.js";
};